"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiInUsd = exports.HiInInr = exports.EnInUsd = exports.EnInInr = void 0;
class EnInInr {
    constructor() {
        this.locale = "en-in";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "INR",
            symbol: "₹",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n",
        };
    }
}
exports.EnInInr = EnInInr;
class EnInUsd {
    constructor() {
        this.locale = "en-in";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n",
        };
    }
}
exports.EnInUsd = EnInUsd;
class HiInInr {
    constructor() {
        this.locale = "hi-in";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "INR",
            symbol: "₹",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n",
        };
    }
}
exports.HiInInr = HiInInr;
class HiInUsd {
    constructor() {
        this.locale = "hi-in";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n",
        };
    }
}
exports.HiInUsd = HiInUsd;
